export default __webpack_public_path__ + "static/media/Ford Mustang.b4c07593.png";